import _isNil from 'lodash/isNil';
/**
 * reverse kebab case date
 * @param dateStr
 */
export function reverseKebabCaseDate(dateStr) {
  return ("" + dateStr).split('-').reverse().join('-');
}

/**
 * stringifyQueryParams
 * @param {Object} params
 * @returns string
 */
export function stringifyQueryParams(params) {
  return Object.entries(params).map(function (_ref) {
    var key = _ref[0],
      val = _ref[1];
    return !_isNil(val) ? key + "=" + val : '';
  }).filter(Boolean).join('&');
}